import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DatatableComponent } from '@basis/angular-components';
import { SelectItem } from 'primeng/primeng';
import { Locale } from "../util/locale.ptbr";

@Component({
    selector: 'filter-lotacao',
    template: `
        <form [formGroup]="filtro" novalidate>
            <div class="ui-g-12 ui-md-12 ui-lg-12 form-group">
                <form-text class="ui-g-12 ui-md-6 ui-lg-4" label="Lotação" formControlName="nome"></form-text>
                <form-text class="ui-g-12 ui-md-6 ui-lg-4" label="Cidade" formControlName="cidade"></form-text>                                
                <form-calendar formControlName="data_cadastro" class="ui-g-12 ui-md-4" label="Data Cadastro" [locale]="locale.ptBR"></form-calendar>
                <form-select class="ui-g-12 ui-md-6 ui-lg-4" label="UF" formControlName="id_uf" [options]="listaUf | formatSelectItem:'id':'nome'"></form-select>
                <form-select class="ui-g-12 ui-md-6 ui-lg-4" label="Situação" formControlName="id_situacao" [options]="listaSituacao | formatSelectItem:'id':'nome'"></form-select>
            </div>
        </form>
        <div class="ui-g-12">
        </div>
        
    <div class="ui-g-10 ui-md-4 ui-lg-3" style="float: right; margin-right: 9%;" *ngIf="btnEnabled">
        <button pButton type="button" [label]="btnLabel" class="ui-button-mandalay" icon="ui-icon-plus" [routerLink]="['./cadastrar']" ></button>
    </div>

    <div class="ui-g-10 ui-md-4 ui-lg-3" style="float: right; margin-right: 20px;" *ngIf="btnEnabledConsultar && btnEnabled">
        <button pButton type="button" [label]="btnLabelConsultar" class="ui-button" icon="ui-icon-search" (click)="consultar($event)" ></button>
    </div>

    <div class="ui-g-10 ui-md-4 ui-lg-3" style="float: right; margin-right: 9%;" *ngIf="btnEnabledConsultar && !btnEnabled">
        <button pButton type="button" [label]="btnLabelConsultar" class="ui-button" icon="ui-icon-search" (click)="consultar($event)" ></button>
    </div>
    `})
export class FilterLotacaoComponent {
    constructor(public locale: Locale) { }
    @Input() filtro: FormGroup;
    @Input() listagem: DatatableComponent;
    @Input() listaSituacao: SelectItem[];
    @Input() listaUf: SelectItem[];
    @Input() btnEnabled: boolean = true;
    @Input() btnEnabledConsultar: boolean = true;
    @Input() btnLabel: string = "Adicionar";
    btnLabelConsultar:string = "Consultar"

    /**
     * Envia a consulta a ser realizada
     */
    consultar(event: any) {
        this.listagem.refresh(this.filtro.value);
    }
}


// WEBPACK FOOTER //
// ./src/app/lotacao/lotacao-filter.component.ts